import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { Typography, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { PersonModel } from '../../models/personModel';
import { listPersonsReq } from '../../api/person/listApi';
import { personHasRole } from '../../utils/personUtils';
import { PersonRole } from '../../models/eums/personRole';
import { localization } from 'config/localization';

function Officials() {
  const { t } = useTranslation();
  const [officials, setOfficials] = useState<PersonModel[]>();
  const history = useHistory();

  const [isAdminOrEditor, setIsAdminOrEditor] = useState(false);

  useEffect(() => {
    async function getOfficialsBasicInfo() {
      let response;
      personHasRole(PersonRole.Admin)
        ? (response = await listPersonsReq())
        : (response = await listPersonsReq(PersonRole.Referee));
      setOfficials(response.data);
    }

    getOfficialsBasicInfo();
    handleUserPermissions();
  }, [setOfficials, setIsAdminOrEditor]);

  function handleUserPermissions() {
    personHasRole(PersonRole.Admin) ? setIsAdminOrEditor(true) : setIsAdminOrEditor(false);
  }

  function handleOnRowClick(event?: React.MouseEvent, official?: PersonModel) {
    if (official?.personUUID) {
      history.push(`/officials/official-details/${official.personUUID.personId}`);
    }
  }

  return (
    <MaterialTable
      options={{
        search: true,
        minBodyHeight: '80vh',
        pageSize: 10,
        headerStyle: {
          fontWeight: 'bold',
          backgroundColor: '#F5F5F5',
        },
      }}
      localization={localization()}
      columns={[
        { title: t('first_name'), field: 'preferredGivenName' },
        { title: t('last_name'), field: 'preferredFamilyName' },
        {
          title: t('email'),
          render: official =>
            official.coms?.emailAddresses.map((email, index) => (
              <Tooltip key={index} title={t<string>(email.emailType)}>
                <Typography variant='body2'>{email?.emailAddress}</Typography>
              </Tooltip>
            )),
        },
        {
          title: t('phone'),
          render: official =>
            official.coms?.phoneNumbers.map((phone, index) => (
              <Tooltip key={index} title={t<string>(phone.phoneType)}>
                <Typography variant='body2'>{phone?.phoneNumber}</Typography>
              </Tooltip>
            )),
        },
        {
          title: t('certifications'),
          cellStyle: { width: '100%' },
          field: 'certifications',
          customFilterAndSearch: (filter, rowData) => {
            return !!rowData.certifications?.find(cert => {
              if (!cert.type) return false;

              return cert.type.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
            });
          },
          render: official =>
            official.certifications?.map((cert, index) => (
              <Typography key={index}>{t(cert.type || '')}</Typography>
            )),
        },
      ]}
      data={officials || []}
      title={t('officials')}
      onRowClick={isAdminOrEditor ? handleOnRowClick : undefined}
    />
  );
}

export default Officials;
